import { render, staticRenderFns } from "./ComFile.vue?vue&type=template&id=2bcf943a&scoped=true&"
import script from "./ComFile.vue?vue&type=script&lang=js&"
export * from "./ComFile.vue?vue&type=script&lang=js&"
import style0 from "./ComFile.vue?vue&type=style&index=0&id=2bcf943a&prod&scoped=true&lang=css&"
import style1 from "./ComFile.vue?vue&type=style&index=1&id=2bcf943a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcf943a",
  null
  
)

export default component.exports